// eslint-disable-next-line import/prefer-default-export
export const getFlag = (rootState, flag) => {
    const { flags } = rootState.flags
    return flags[flag]
}
